import Route from '@ember/routing/route';

export default class VisitorsSettingsPoliciesIndexRoute extends Route {
  titleToken = 'Policies';
}
